import React, { useState } from 'react';
import AddEditForm from './form';
import ViewList from './view';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import { Tag, ArrowLeft, Plus } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'app/components/ui/button';

const AttributesValues = () => {
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleEdit = attribute => {
    setSelectedAttribute(attribute);
  };

  const handleFormSubmit = data => {
    setSelectedAttribute(null);
  };

  const handleBackToAttributes = () => {
    navigate('/products/attributes');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <Button
                variant="outline"
                size="sm"
                onClick={handleBackToAttributes}
                className="h-8 w-8 p-0 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                <ArrowLeft className="w-4 h-4" />
              </Button>
              <div className="w-10 h-10 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center">
                <Tag className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                  Attribute Values
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  Manage values for this attribute
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Add/Edit Form */}
          <Card className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-white/20 dark:border-gray-700/50 col-span-5">
            <CardHeader className="border-b border-gray-100 dark:border-gray-700">
              <CardTitle className="flex items-center space-x-2 text-lg">
                <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"></div>
                <span>Value Management</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <AddEditForm
                selectedAttribute={selectedAttribute}
                onFormSubmit={handleFormSubmit}
              />
            </CardContent>
          </Card>

          {/* Values List */}
          <Card className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-white/20 dark:border-gray-700/50 col-span-7">
            <CardHeader className="border-b border-gray-100 dark:border-gray-700">
              <CardTitle className="flex items-center space-x-2 text-lg">
                <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></div>
                <span>Existing Values</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <ViewList onEdit={handleEdit} />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AttributesValues;
